import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["parent", "dependent"]
  static values = {
    parentAttr: { type: String, default: "parentId" }
  }

  connect() {
    this.allOptionsByTarget = new Map()

    // Initialize all dependent targets
    this.dependentTargets.forEach(target => {
      this.allOptionsByTarget.set(target, this.getAllOptions(target))
    })

    // Wait for TomSelect to initialize before filtering
    this.dependentTargets.forEach(target => {
      if (target.tomselect) {
        this.filterTarget(target)
      } else {
        // Poll for TomSelect initialization
        const checkTomSelect = setInterval(() => {
          if (target.tomselect) {
            clearInterval(checkTomSelect)
            this.filterTarget(target)
          }
        }, 50)

        // Timeout after 2 seconds
        setTimeout(() => clearInterval(checkTomSelect), 2000)
      }
    })
  }

  getAllOptions(selectElement) {
    // Always read from the original DOM options, not TomSelect's processed options
    return Array.from(selectElement.querySelectorAll("option")).map(option => ({
      value: option.value,
      text: option.textContent,
      parentId: option.dataset[this.parentAttrValue],
      dataAttrs: Object.keys(option.dataset).reduce((acc, key) => {
        acc[key] = option.dataset[key]
        return acc
      }, {})
    }))
  }

  filter() {
    // Filter all dependent targets
    this.dependentTargets.forEach(target => {
      this.filterTarget(target)
    })
  }

  filterTarget(selectElement) {
    const parentId = this.getParentValue()
    const tomSelect = selectElement.tomselect

    if (!tomSelect) return

    const allOptions = this.allOptionsByTarget.get(selectElement)
    if (!allOptions) return

    const currentValue = tomSelect.getValue()

    // Clear current value first
    tomSelect.clear(true)

    // Clear all options
    tomSelect.clearOptions()

    let currentValueBelongsToParent = false

    allOptions.forEach(option => {
      if (!option.value) return

      // Check if option belongs to parent
      // Handle both single parent ID and comma-separated list of parent IDs
      let belongsToParent = false
      if (!parentId) {
        belongsToParent = true
      } else if (option.parentId) {
        const parentIds = option.parentId.split(',').map(id => id.trim())
        belongsToParent = parentIds.includes(parentId)
      }

      if (belongsToParent) {
        tomSelect.addOption({
          value: option.value,
          text: option.text,
          ...option.dataAttrs
        })

        if (currentValue === option.value) {
          currentValueBelongsToParent = true
        }
      }
    })

    // Refresh the dropdown
    tomSelect.refreshOptions(false)

    // Set value after refreshing
    if (currentValue && currentValueBelongsToParent) {
      tomSelect.setValue(currentValue, false)
    }
  }

  getParentValue() {
    const parentSelect = this.parentTarget
    return parentSelect.tomselect?.getValue() || parentSelect.value
  }
}
